import React from "react";

import { BrowserRouter, Route, Routes } from "react-router-dom";


import Login from "./Login/login";
import Home from "./Home/home";
import GlobalLayout from "./GlobalLayout/globalLayout";
import Appointment from "./Appointment/appointment";
import Patients from "./Patients/patients";
import Prescription from "./Prescription/prescription";
import Library from "./Library/library";
import ConsultantProfile from "./ConsultantProfile/consultantProfile";
import AuthLayout from "./AuthLayout/authLayout";
import Register from "./Register/register";
import AboutUs from "./Support/aboutUs";
import Faq from "./Support/faq";
import SendEmail from "./NewPassword/sendEmail";
import ResetPassword from "./NewPassword/resetPassword";
import PasswordCreation from "./PasswordCreation/passwordCreation";


export default () => {
    return (
        <BrowserRouter basename={""}>
            <Routes>
                <Route element={<AuthLayout />}>
                    <Route path="/" element={<Login />}></Route>
                    <Route path="/register" element={<Register />}></Route>
                    <Route path="/sendEmail" element={<SendEmail />}></Route>
                    <Route path="/ResetPassword" element={<ResetPassword />}></Route>
                    <Route path="/confirmPassword" element={<PasswordCreation />}></Route>
                </Route>
                <Route path="/mobithera" element={<GlobalLayout />}>
                    <Route index path="/mobithera/home" element={<Home />}></Route>
                    <Route index path="/mobithera/appointment" element={<Appointment />}></Route>
                    <Route index path="/mobithera/patients" element={<Patients />}></Route>
                    <Route index path="/mobithera/library" element={<Library />}></Route>
                    <Route index path="/mobithera/prescription" element={<Prescription />}></Route>
                    <Route index path="/mobithera/consultantProfile" element={<ConsultantProfile />}></Route>
                    {/* <Route index path="/mobithera/aboutUs" element={<AboutUs />}></Route> */}
                    <Route index path="/mobithera/faq" element={<Faq />}></Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};


